<div class="wrapper">
  <div class="header">
    <div class="title-wrapper">
      <cs-icon-button
        class="btn-back"
        iconType="icon"
        icon="fi-arrow-left"
        color="secondary"
        size="12"
        (buttonClick)="goBackBuyCryptoWallet()"
      ></cs-icon-button>
      <span class="title">Buy Crypto</span>
    </div>
    <cs-icon-button
      class="btn-close"
      iconType="icon"
      icon="fi-x"
      color="secondary"
      size="12"
      (buttonClick)="cardDepositService.closeCardModal()"
    ></cs-icon-button>
  </div>

  <div class="scroll-cont">
    <div class="section">
      <div class="cont">
        <app-payment-iq [method]="'deposit'" [curPaymentData]="data"></app-payment-iq>
      </div>

      <div class="confirm-note-list">
        <div class="confirm-note-item">
          <span class="mark">
            {{ data.getAmount || 0 | currencyValue: data.getAmountCurrency }}
          </span>
          <img class="currency-img" [src]="data.getAmountCurrency | currencyIcon" />
          <p>will be deposited in your wallet</p>
        </div>
      </div>

      <div class="note">
        <span>Need help?</span>
        <cs-button
          (buttonClick)="contactSupport()"
          color="secondary"
          width="auto"
          size="small"
          label="Get live support"
        ></cs-button>
      </div>
    </div>
  </div>
</div>
